import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-modal-alteracoes',
  templateUrl: './modal-alteracoes.component.html',
  styleUrls: ['./modal-alteracoes.component.css']
})
export class ModalAlteracoesComponent implements OnInit, OnDestroy {

  titulo: string = 'Atenção';
  mensagem: string = 'Mensagem';
  labelFechar: string = 'Voltar';
  labelOk: string = 'Continuar';
  showFecharBtn: boolean = true;
  showOkBtn: boolean = true;
  isTituloVermelho: boolean = false;

  @Output() confirmValue = new EventEmitter<boolean>();

  alive: boolean = true;

  constructor(private bsModalRef: BsModalRef) { }

  ngOnInit() {
    console.log('Criou modal aviso de alterações');
  }

  ngOnDestroy() {
    this.alive = false;
    console.log('Destruiu modal aviso de alterações');
  }

  showModal(
    options?: {
      titulo?: string,
      mensagem?: string,
      labelFechar?: string,
      labelOk?: string,
      showFecharBtn?: boolean,
      showOkBtn?: boolean,
      isTituloVermelho?: boolean
    }): void {

    if (options) {
      this.titulo = options.titulo || this.titulo;
      this.mensagem = options.mensagem || this.mensagem;
      this.labelFechar = options.labelFechar || this.labelFechar;
      this.labelOk = options.labelOk || this.labelOk;
      this.showFecharBtn = options.showFecharBtn || this.showFecharBtn;
      this.showOkBtn = options.showOkBtn || this.showOkBtn;
      this.isTituloVermelho = options.isTituloVermelho || this.isTituloVermelho;
    }

  }

  onClickOk() {
    this.confirmValue.next(true);
    this.bsModalRef.hide();
  }

  onClickClose() {
    this.confirmValue.next(false);
    this.bsModalRef.hide();
  }

}
